<template>
  <CardTable
    :loading="loadingServices"
    header="Past Services"
    :tableHeaders="headers"
    :tableData="pastServicesTableData"
  />
</template>

<script>
import CardTable from '@shared/components/service/component/CardTable.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'PastServicesTable',
  components: { CardTable },
  data() {
    return {
      headers: [{
        text: 'DATE',
        align: 'start',
        sortable: true,
        filterable: false,
        value: 'date',
      }, {
        text: 'TECHNICIAN',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'name',
      },
      {
        text: 'JOB TYPE',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'serviceType',
      }, {
        text: 'SERVICE ISSUES',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'serviceIssues',
      }],
    };
  },
  computed: {
    ...mapState({
      loadingServices: (state) => state.service.loadingServices,
      pastServiceList: (state) => state.service.pastServiceList,
      serviceInfo: (state) => state.service.serviceInfo,
    }),
    ...mapGetters([
      'pastServicesTableData',
    ]),
  },
  mounted() {
    if (this.serviceInfo.customerId) {
      this.$store.dispatch('getPastServices', {
        corpId: this.serviceInfo.corpId,
        customerId: this.serviceInfo.customerId,
      });
    }
  },
};
</script>
